import CRUDReducer from '../CRUDReducer';
import postAction from '../../actions/fan_feed/fan_feed_posts';

const postCRUDReducer = new CRUDReducer(postAction);

export default (state, action) => postCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/fan_feed/fan_feed_posts.ts